import { useCollectionPhotos } from 'api/assetManifest';
import { PhotoGallery } from 'components/shared/PhotoGallery';

interface CollectionImageGalleryProps {
    /** Manifest collection name, e.g. `causes-supported`. */
    name: string;
}

/**
 * Photographs that belong to no event.
 *
 * These used to be fetched by passing the gallery a fabricated event —
 * `<EventImageGallery event={{ eventTitle: 'Causes Supported' }} />` — because
 * the lookup was by title and a title was the only key available. Now that
 * events are addressed by id, a collection can simply be its own thing.
 */
export const CollectionImageGallery = ({ name }: CollectionImageGalleryProps) => (
    <PhotoGallery photos={useCollectionPhotos(name)} />
);
